export enum NominatimSearchType {
  FREE = 'q',
  AMENITY = 'amenity',
  STREET = 'street',
  CITY = 'city',
  COUNTY = 'county',
  STATE = 'state',
  COUNTRY = 'country',
  POSTALCODE = 'postalcode',
}
